/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus-icon.svg";
import LocationIcon from "../../../assets/icons/location-icon.svg";
import MobileIcon from "../../../assets/icons/mobile-icon.svg";
import EmailIcon from "../../../assets/icons/email-icon.svg";
import EditIcon from "../../../assets/icons/edit-icon.svg";
import DeleteIcon from "../../../assets/icons/delete-icon.svg";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import AddAddress from "../../../components/popup/AddAddress";
import DeleteModal from "../../../components/popup/DeleteModal";
import { address } from "../../../Data/data";
import {
  ADD_DELIVERY_ADDRESS,
  ADD_EDIT_USER,
  DELETE_DELIVERY_ADDRESS,
  LIST_DELIVERY_ADDRESS,
  USER_DETAILS,
  VIEW_DELIVERY_ADDRESS,
} from "../../../Redux/SagaAction/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import { userpopupShowingCount } from "../../../Redux/Slices/AuthSlice";

const MyAddress = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { currentActiveModel } = useSelector((e) => e.AuthSlice);
  console.log(currentActiveModel === 6, "currentActiveModel");
  const { loading } = useSelector((state) => state.ProductSlice);
  // const [showEdit, setShowEdit] = useState(false);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [addressTitle, setAddressTitle] = useState("");
  let [deleteId, setDeleteId] = useState(null);
  let [editId, setEditId] = useState(null);
  const dispatch = useDispatch();

  const { listAddress } = useSelector((e) => e?.DeliveryAddressSlice);

  // const handleAddAddressPopup = () => {
  //   setAddressTitle("Add Address");
  //   setShowAddrss(true);
  //   setShowEdit(false);
  //   setEditId(null);
  // };

  // const handleEdit = (id) => {
  //   setAddressTitle("Edit Address");
  //   setShowAddrss(false);
  //   setShowEdit(true);
  //   setEditId(id);
  // };

  // const handleDelete = (id) => {
  //   setshowDeleteModal(true);
  //   setDeleteId(id);
  // };

  // const showModal = (modalType, id) => {
  //   if (modalType === "Add Address") {
  //     setShow(true);
  //     setAddressTitle("Add Address");
  //     setEditId(id);
  //   } else if (modalType === "Edit Address") {
  //     setShow(true);
  //     setAddressTitle("Edit Address");
  //     setEditId(id);
  //   }
  // };
  // useEffect(() => {
  //   dispatch({
  //     type: USER_DETAILS,
  //     payload: { addressId: "648961f3b8944a36464a9d73" },
  //   });
  // }, [USER_DETAILS]);
  const ref = useRef();
  const ref2 = useRef();
  useEffect(() => {
    dispatch({
      type: LIST_DELIVERY_ADDRESS,
    });
  }, []);

  return (
    <>
      <div className="table-content">
        <div className="add-address">
          <div className="title-wraper">
            <div className="table-title">{`${t(
              "myaccount.deliveryaddress.title"
            )}`}</div>
            <div
              className="icon-wrapper"
              onClick={() => {
                dispatch(userpopupShowingCount(6));
                // showModal("Add Address", null);
                // handleAddAddressPopup();
              }}
            >
              <PlusIcon />
              <span>{`${t("myaccount.deliveryaddress.addaddress")}`}</span>
            </div>
          </div>
          <div className="content-wrapper">
            <Row className="custom-row-space">
              {listAddress?.map((add, i) => {
                return (
                  <Col xl="6" key={i}>
                    <div className="graybg address-details">
                      <div className="address-inner">
                        <div className="custom-radio">
                          <input
                            type="radio"
                            id={add?.addressId}
                            name="address"
                          />
                          <label htmlFor={add?.addressId}></label>
                        </div>

                        <div className="customer-detail">
                          <div className="customer-name">
                            {add?.firstName} {add?.lastName}
                          </div>
                          <div className="personal-info">
                            <div className="address-detail">
                              <img
                                src={LocationIcon}
                                style={{ marginTop: "3px" }}
                              />{" "}
                              <span>
                                {add?.houseNo},{add?.areaName},{add?.cityName}-
                                {add?.stateName},{add?.countryName},
                                {add?.zipCode}{" "}
                              </span>
                            </div>
                            <div className="contact-info">
                              <div className="contact">
                                <img src={MobileIcon} />{" "}
                                <span>{add?.phoneNo}</span>
                              </div>
                              <div className="mail-detail">
                                <img src={EmailIcon} />{" "}
                                <span>{add?.email}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="action">
                        <img
                          src={EditIcon}
                          className="cursor-pointer action-icon"
                          onClick={() => {
                            // dispatch({
                            //   type: VIEW_DELIVERY_ADDRESS,
                            //   payload: {addressId: add?.addressId},
                            //   callback: () => {
                            //     dispatch(userpopupShowingCount(6))
                            //   },
                            // });
                            dispatch(userpopupShowingCount(6));
                            const viewData = {
                              ...add,
                              cityId: { _id: add?.cityId, name: add?.cityName },
                              stateId: {
                                _id: add?.stateId,
                                name: add?.stateName,
                              },
                              countryId: {
                                _id: add?.countryId,
                                name: add?.countryName,
                              },
                            };
                            // delete viewData?.cityName
                            console.log(viewData, "viewData");
                            ref.current = viewData;
                          }}
                        />
                        <img
                          src={DeleteIcon}
                          className="cursor-pointer action-icon"
                          onClick={() => {
                            setShow(true);
                            ref2.current = add;
                          }}
                          // onClick={() => dispatch({type:DELETE_DELIVERY_ADDRESS,payload:{addressId:add?.addressId}})}
                        />
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
      </div>
      {currentActiveModel === 6 && (
        <AddAddress
          show={currentActiveModel === 6}
          addressData={ref.current}
          clear={() => {
            ref.current = null;
          }}
        />
      )}
      {/* <AddAddress
        show={show}
        setShow={setShow}
        title={addressTitle}
        editId={editId}
        // showModal={showModal}
      /> */}
      {show && (
        <DeleteModal
          myAddress
          showDeleteModal={show}
          setshowDeleteModal={setShow}
          deleteId={ref2.current.addressId}
        />
      )}
    </>
  );
};

export default MyAddress;
